import { GET_LIST, GET_MANY_REFERENCE } from 'react-admin';
import { REFERENCE_TO_RESOURCE } from './constants';
import { getQuery } from './getQuery';
import { DataProviderPayload, DataProviderResource, FetchType } from './types';

const apiUrl = import.meta.env.VITE_API_URL;

export const getUrl = (type: FetchType, _resource: DataProviderResource, payload: DataProviderPayload): string => {
  const { id, target, targetId, action } = payload;
  const resource = REFERENCE_TO_RESOURCE[_resource] || _resource;

  const base = `${apiUrl}/${resource}`;

  // Build path segments consistently
  const segments = [id, target, targetId, action].filter(Boolean);

  const path = [base, ...segments].join('/');

  // Only list-type requests get query params
  if (type === GET_LIST || type === GET_MANY_REFERENCE) {
    const query = getQuery(payload);
    return query ? `${path}?${query}` : path;
  }

  return path;
};
